import React from "react";
import {UnpivotDataConfiguration} from "./configuration/unpivot-data-configuration";
import {PreviewTab} from "../preview-tab/preview-tab";

export const UnpivotDataStepPanelTabs = {
    configuration: UnpivotDataConfiguration,
    preview: PreviewTab,
};
